const productRequestTypes = {
  all: { value: 'all', title: 'All' },
  finder: { value: 'finder', title: 'Product Finder', key: 'product_finder' },
  bidding: { value: 'bidding', title: 'Product Bidding', key: 'product_bidding' },
}

export default productRequestTypes
